import React from 'react';

import { Consulting } from '@layouts/Consulting';
import { DescriptionWithImage, QuoteWithButtons } from '@components';
import { Header } from './components';
import { contacts } from '@store/ContactData';
import CalculatorImage from '@static/images/figures/calculator.webp';

import * as styles from './FixedPrice.module.scss';

export const FixedPriceTrial: React.FC = () => {
	return (
		<>
			<Header />
			<QuoteWithButtons
				className="gray-bg"
				author={{
					name: contacts[0].name,
					position: contacts[0].position,
					email: contacts[0].email,
					linkedIn: contacts[0].linkedin,
					photo: contacts[0].image,
				}}
			>
				<h2 className="font-size-22 mb-2 pr-5">
					What kind of competencies are you looking for?
				</h2>
				<p className="font-size-sm">
					Contact me to discuss your requirements and build your dedicated IT
					team together with us.
				</p>
			</QuoteWithButtons>
			<DescriptionWithImage
				image={CalculatorImage}
				className="white-bg"
				imageClassName={styles.calculatorImage}
				imageBoxClassName="justify-content-center justify-content-md-end"
				imageOnRight
			>
				<h2 className="font-size-md mb-2">
					How do you calculate a fixed-price trial?
				</h2>
				<div className="font-size-sm limit-text">
					The fixed price model is only a trial version. Time and costs of work
					depend on the client's budget. All the work is planned in the
					beginning - every step and particular result.
				</div>
			</DescriptionWithImage>
			<Consulting />
		</>
	);
};
